"use strict";

// todo:
// - zbavit se posílání eventů == napříč assety, kde je používají
// samosepřidání komponent jako combobox + některých bs fcí do seznamu fcí volaných po provedení ajaxu ?

var wpAjax = require('./Ajax');

if(!(window.VutRequiredLib && (typeof window.VutRequiredLib === 'object'))) {
    window.VutRequiredLib = {};
}

let VutRequiredLib = {
    Ajax: wpAjax,
    baseUrl:window.gl_url_www || '/',
    lang: window.gl_lang_code || 'cs',
};

// cheme aby to co uz je v required tam zustalo
window.VutRequiredLib = Object.assign(VutRequiredLib, window.VutRequiredLib);


let MINIMAL_RESOLVING_TIME = 200;

const defaults = {
    async: true, // lze 
    preloader: true, // false - vůbec nedělá preloader
    drop_old_responses : false, // pokud se odesílá více požadavků, automaticky ignoruj starší odpovědi (combobox)
    preloader_parent: null, // kam by default cpát preloader 
    minimal_resolving_time: MINIMAL_RESOLVING_TIME,
    history:true, // povolit handler pushurl
    target: null, // target pro eventy
};

let Ajax = VutRequiredLib.Ajax;
import {Handlers, exec_body_scripts} from './handlers.js';
import {Form} from './form.js';

export class VutAjax {

    static onCompleteCallbacks = [];

    static click(event) {
        if (!event.button) { // left click only

            let selector=VutAjax.click.register.map(entry=>entry.selector).filter(v=>v).join(',');

            if (event.target.closest('.vut-ajax-preloader')) {

                event.preventDefault?.();
                event.stopImmediatePropagation?.();
                event.stopPropagation?.();

                return false;
                
            }

            let target;

            if (selector&&(target = event.target.closest(selector))) {

                event.preventDefault?.();
                event.stopImmediatePropagation?.();
                event.stopPropagation?.();

                VutAjax.click.register.find((r)=>{
                    if (target.matches(r.selector)) {
                        if (target.matches('a[href]')) {
                            VutAjax.handleEventAnchor(target, r.that);
                        } else {
                            VutAjax.handleEventForm(target, r.that);                            
                        }
                        return 1;
                    }
                });

                return false;
                
            }

        }
    }

    static handleEventAnchor(target, that) {

        let ajax = new Ajax(target.href||'');
        
        return VutAjax.doAjax(ajax, that, target);
        
    }

    static handleEventForm(target, that) {

        let form=target.closest('form');

        if (form) {

            let ajax = new Ajax(form.action||'', form.method&&form.method.toLowerCase()=='post'?"POST":"GET", false);
            
            Form.serialize(form, ajax);

            if(target.name){
                ajax.addData(target.name, target.value || 1);
            }


            return VutAjax.doAjax(ajax, that, target);
            
        } else { console.error("Nenalezen form, pravdepodobne chyba v nastaveni tridy"); }

    }

    static dispatch(name, target, params={}){
        if (typeof target == 'string') {
            try {target=document.querySelector(target);}
            catch(e) {}
        }
        if (!((target instanceof HTMLElement)&&(target.offsetParent||target.isConnected))) {target=document.body;}
        if (typeof CustomEvent === "function") {
            try {
                let ee=new CustomEvent(name, {bubbles:true});
                for (let k in params) {
                    ee[k]=params[k];
                }
                target.dispatchEvent(ee);
            } catch(e) {console.warn("nelze vyvolat custom event "+name, e);}
        } else {console.warn("nelze vyvolat custom event "+name+" - nepodporováno");}
    }

    static processAction(data, options, that, ajax){

        let errors=0;

        if (Array.isArray(data)) {
            data.forEach((action)=>{
                errors = VutAjax.processSingleAction(action, options, that, ajax) ? errors+1 : errors;
            });
        } else if (data && (typeof data == 'object')) {
            const keysArray = Object.keys(data);
            keysArray.forEach(key => {
                let action = data[key];
                if (action !== null && action.type !== undefined) {
                    errors = VutAjax.processSingleAction(action, options, that, ajax) ? errors+1 : errors;
                }
            });
        }

        return errors;
    }


    static processSingleAction(action, options, that, ajax) {
        try{
            let type=(typeof action.type == 'string')?action.type.toLowerCase():action.type;
            if(type && (typeof that.actionHandler[type] == "function")){
                that.actionHandler[type](action, options, ajax);
            } else if(type && (typeof Handlers[type] == "function")){
                Handlers[type](action, options, that, ajax);
            } else {
                console.error("Neznáma akce ", action.type);
                return false;
            }
        } catch(e){
            console.log("CHYBA", e);
            return false;
        }
        return true;
    }
    

    static doAjax(ajax, that, addOptions) {


        if ((ajax instanceof Ajax)&&(that instanceof VutAjax)) {
            
            VutAjax.isUnload=false;
            let options=VutAjax.setOptions(defaults, that.options);
            
            // pokud se místo options předává element, hledá se vhodný rodič pro preloader //
            if (addOptions instanceof HTMLElement) { 
                options.preloader_parent=addOptions.closest('body, .vutAjax-preloader-here');
                if (addOptions.dataset.vutajaxOptions) {
                    try {
                        let dataOptions=JSON.parse(addOptions.dataset.vutajaxOptions);
                        delete dataOptions.async;
                        options=VutAjax.setOptions(options, dataOptions);
                        options.target ??= addOptions;
                    } catch(e) {
                        console.warn("Chyba parsování data-vutajax-options:", e)
                    };
                };
            } else {
                options=VutAjax.setOptions(options, addOptions);
            }

            let preloader_parent = options.preloader_parent instanceof HTMLElement ? options.preloader_parent : document.body;

            if (typeof options.preloader_parent == 'string') {
                try {
                    let p = document.querySelector(options.preloader_parent);
                    preloader_parent = p ?? preloader_parent;
                }catch(e) {}
            }

            if ((!options.async)&&that.request) {
                VutAjax.dispatch("vutAjaxAbort", options.target instanceof HTMLElement ? options.target : preloader_parent,  {vutAjax:that, ajax});
                let ret = new Promise((resolve, reject)=>reject('aborted'));
                ret.catch(()=>console.trace('vutajax abort;', ajax, that, addOptions));
                return ret;
            }

            ajax.addData({ajax: 1});

            let reqNo=that.reqNo;
            
            try {
                
                let start=performance.now();
                
                //// pokud je specifikován jiný resolve time požadavku, než má instance vutajaxu, o rozdíl se posune start ////
                if (options.minimal_resolving_time != that.options.minimal_resolving_time) {
                    start -= (that.options.minimal_resolving_time - options.minimal_resolving_time);                    
                }
                let ret = new Promise((resolve, reject)=> {

                    let t0=performance.now();

                    ajax.send().then((data) => {
                        let t1 = performance.now();
                        that.request--;
                        if (window.gl_debug) {console.log("ajax response: ", t1 - t0, "ms");}
                        if (options.drop_old_responses && (reqNo < that.reqNo)) {
                            return;
                        }
                        if (data && !data.errorStatus) {
                            // neni chyba v ajax komunikaci -> zpracuji se akce
                            VutAjax.dispatch("vutAjaxLoad", options.target instanceof HTMLElement ? options.target : preloader_parent, {data, vutAjax:that, ajax});
                            let err = VutAjax.processAction(data.data, options, that, ajax);

                            if (Array.isArray(that._afterAjax)) {
                                that._afterAjax.forEach(fn => {
                                    try {
                                        fn();
                                    } catch (e) {
                                        console.error(e);
                                        console.error("vut ajax after chyba funkce", fn);
                                    }
                                });
                            }

                            VutAjax.dispatch("vutAjaxProcess", options.target instanceof HTMLElement ? options.target : preloader_parent,  {data, vutAjax:that, ajax, err});
                            if (window.gl_debug) {
                                console.log("ajax process: ", performance.now() - t1, "ms");
                            }

                            VutAjax.onCompleteCallbacks.forEach((fn) => {
                                fn(data);
                            });

                            resolve(data);

                        } else {
                            if (!VutAjax.isUnload) {
                                throw(data);
                            }
                        }
                    }).catch((data) => {
                        console.error("Ajax error: ", data);
                        if (window.gl_debug) {
                            console.log("ajax response: ", performance.now() - t0, "ms");
                        }
                        VutAjax.dispatch("vutAjaxError", options.target instanceof HTMLElement ? options.target : preloader_parent,  {data, vutAjax:that, ajax})
                        reject(data);
                    }).finally(() => {
                        if (options.preloader) {
                            VutAjax.closePreloader(preloader_parent, start, that);
                        }
                    })

                    if (options.preloader) {VutAjax.openPreloader(preloader_parent, that);}
                    that.request++;

                });
                ret.catch(()=>null); // promisa musí mít catch, jinak řve... //
                return ret;



            } catch(e) { console.error(e); alert("AJAX ERROR"); }
        }
        
    }

    constructor (selector, options) {
        
        this.setOptions(options);
        this.selector=null;
        this.actionHandler={};
        this._afterAjax=[];
        this.request = 0;

        this.exec_body_scripts=exec_body_scripts;
        this.__exec_body_scripts=exec_body_scripts;

        if (selector) {
            try {                
                document.querySelector(selector);
                this.selector=selector;
                VutAjax.click.register.push({selector:selector, that:this});
            } catch(e) {
                console.warn('Instance VutAjax: neplatný selector', selector);
            }
        }

    }

    init() {}
    
    addActionHandler(key, fn){
        if(typeof fn === "function") {
            if (typeof key == 'string') key=key.toLowerCase();
            this.actionHandler[key] = fn.bind(this);
        }else{
            console.error("Pokus o pridani neplatne funkce: ", key)
        }
    }


    addAfterAjax(fn) {
        if(typeof fn === "function") {
            (this._afterAjax = this._afterAjax.filter(f => f !== fn)).push(fn);
        }else{
            console.error("Pokus o pridani neplatne funkce: ", fn);
        }
    }

    addAfterAjaxOnce(fn) {
        if(typeof fn === "function") {
            let tmp = () => {
                try { fn(); } catch(e) {console.error(e);}
                this.removeAfterAjax(tmp);
            }
            this._afterAjax.push(tmp);
        }else{
            console.error("Pokus o pridani neplatne funkce: ", fn);
        }
    }


    removeAfterAjax(fn) {
        this._afterAjax = this._afterAjax.filter(f => f !== fn);
    }


    setOptions(options) {
        this.options=VutAjax.setOptions(defaults, options);
    }

    _doAjax(ajax, options) {return VutAjax.doAjax(ajax, this, options)}
    doAjax(ajax, options) {return VutAjax.doAjax(ajax, this, options)}

    _processAction(data) {VutAjax.processAction(data, this)}
    processAction(data) {VutAjax.processAction(data, this)}
    
    openPreloader(parent) {VutAjax.openPreloader(parent, this);}
    showPreloader(parent) {VutAjax.openPreloader(parent, this);}
    
    closePreloader(parent, start) {VutAjax.closePreloader(parent, start, this);}
    hidePreloader(parent, start) {VutAjax.closePreloader(parent, start, this);}

    message(message) {Handlers.message({data:message})}

    static setOptions(defaults, options) {

        let ret = {};

        Object.keys(defaults).forEach((key)=>{
            if (options?.[key] !== undefined) { ret[key]=options[key]; }
            else {ret[key]=defaults[key]}
        });

        return ret;
        
    }

    static openPreloader(parent=document.body, that){
        if (typeof parent == 'string') {
            try {parent=document.querySelector(parent);}
            catch(e) {}
        }
        if (!(parent instanceof HTMLElement)) {parent=document.body;}

        parent.dataset.vutAjaxRequest=(parseInt(parent.dataset.vutAjaxRequest||0)||0)+1;

    }

    static closePreloader(parent=document.body, start=0, that) {

        // zajištění zpětné kompatibility >> někde může smrdět volání vutAjax.closePreloader(start), takže pokud parent je číslo, napravíme......
        if (typeof parent == "number") {
            start = parent;
            parent = document.body;
        }

        if (typeof parent == 'string') {
            try {parent=document.querySelector(parent);}
            catch(e) {}
        }

        if (!(parent instanceof HTMLElement)) {parent=document.body;}

        let stop  = performance.now();
        let diffTime = stop - (start||0);
        let timeout = Math.max(that?.options?.minimal_resolving_time - diffTime, 0);

        setTimeout(()=> {
            if (!(parent.dataset.vutAjaxRequest = Math.max(0, (parseInt(parent.dataset.vutAjaxRequest || 0) || 0) - 1))) {
                parent.removeAttribute('data-vut-ajax-request');
            }
        }, timeout);
      
    }
    
    
    
}

document.addEventListener('click', VutAjax.click);
VutAjax.click.register=[];


window.VutRequiredLib.VutAjax = VutAjax;
